import { Input, Form } from 'antd';
import React from 'react';

import { FormItemProps } from 'antd/es/form/FormItem';
import ItemMap from './map';

export type WrappedLoginItemProps = LoginItemProps;
export type LoginItemKeyType = keyof typeof ItemMap;
export interface LoginItemType {
  UserName: React.FC<WrappedLoginItemProps>;
  Password: React.FC<WrappedLoginItemProps>;
  Mobile: React.FC<WrappedLoginItemProps>;
  Captcha: React.FC<WrappedLoginItemProps>;
}

export interface LoginItemProps extends Partial<FormItemProps> {
  name?: string;
  style?: React.CSSProperties;
  placeholder?: string;
  buttonText?: React.ReactNode;
  getCaptchaButtonText?: string;
  getCaptchaSecondText?: string;
  type?: string;
  defaultValue?: string;
  customProps?: { [key: string]: unknown };
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormItem = Form.Item;

const getFormItemOptions = ({
  onChange,
  defaultValue,
  customProps = {},
  rules,
}: LoginItemProps) => {
  const options: {
    rules?: LoginItemProps['rules'];
    onChange?: LoginItemProps['onChange'];
    initialValue?: LoginItemProps['defaultValue'];
  } = {
    rules: rules || (customProps.rules as LoginItemProps['rules']),
  };
  if (onChange) {
    options.onChange = onChange;
  }
  if (defaultValue) {
    options.initialValue = defaultValue;
  }
  return options;
};

const LoginItem: React.FC<LoginItemProps> = (props) => {
  // This is to prevenheheatstPropsinbandEnter onChange, defaultValue, rules props tabUtil
  const {
    onChange,
    customProps,
    defaultValue,
    rules,
    name,
    getCaptchaButtonText,
    getCaptchaSecondText,
    type,
    status,
    ...restProps
  } = props;

  if (!name) {
    return null;
  }

  // get getFieldDecorator props
  const options = getFormItemOptions(props);
  const otherProps = restProps || {};

  // Filter out status values that aren't valid for Input
  const inputStatus =
    status === 'error' || status === 'warning' ? status : undefined;

  return (
    <FormItem name={name} {...options} status={status}>
      <Input {...customProps} {...otherProps} status={inputStatus} />
    </FormItem>
  );
};

const LoginItems: Partial<LoginItemType> = {};

Object.keys(ItemMap).forEach((key) => {
  const item = (ItemMap as any)[key];
  (LoginItems as any)[key] = (props: LoginItemProps) => (
    <LoginItem
      customProps={item.props}
      rules={item.rules}
      {...props}
      type={key}
    />
  );
});

export default LoginItems as LoginItemType;
